import { formatDuration } from '@air/utilities';

import { type CommentRange } from '~/components/AnnotationsV2/providers/AnnotationV2Provider';

export type FormatCommentTimeLabelArgs = {
  commentRange: CommentRange | null;
  currentTime?: number | null;
};

export const formatCommentTimeLabel = ({ commentRange, currentTime }: FormatCommentTimeLabelArgs) => {
  if (commentRange && commentRange.startTime !== commentRange.endTime) {
    const startTime = Math.min(commentRange.startTime, commentRange.endTime);
    const endTime = Math.max(commentRange.startTime, commentRange.endTime);

    return `${formatDuration(Math.round(startTime))} - ${formatDuration(Math.round(endTime))}`;
  }

  return formatDuration(Math.round(commentRange?.startTime ?? currentTime ?? 0));
};
